import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentDocumentsListItemWireframe from './VeltNotificationsPanelContentDocumentsListItemWireframe/VeltNotificationsPanelContentDocumentsListItemWireframe';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltNotificationsPanelContentDocumentsListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentDocumentsListWireframe.Item = VeltNotificationsPanelContentDocumentsListItemWireframe;
export default VeltNotificationsPanelContentDocumentsListWireframe;
